import { HttpEvent, HttpHandler, HttpInterceptor, HttpInterceptorFn, HttpRequest, HttpResponse } from "@angular/common/http";

import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

const _iso8601 = /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(\.\d+)?(([+-]\d\d:\d\d)|Z)?$/;

function isIso8601(value: string): boolean {
    if (!value) return false;
    return _iso8601.test(value);
}
function convertDates(obj: any): void {
    if (!obj) return;

    Object.keys(obj).forEach(key => {
        if (typeof obj[key] === "string") {
            if (isIso8601(obj[key])) {
                obj[key] = new Date(obj[key]);
            }
        } else if (typeof obj[key] === "object") {
            convertDates(obj[key]);
        }
    });
}

export const datesConversionInterceptor: HttpInterceptorFn = (req, next) => {
    return next(req).pipe(
        tap((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
                convertDates(event.body);
            }
        })
    );
};
